import React from 'react'
import styled from 'styled-components'

import SLHeader from 'broker/views/components/SkeletonLoader/SLHeader'

const TitleWrapper = styled.div`
  margin-bottom: 12px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
`

const Title = styled.div`
  display: inline;
  color: #1C1C1C;
  font-family: "Circular", sans-serif;
  font-size: 18px;
  font-weight: 500;
  line-height: 23px;
  margin-right: 4px;
`

const Subtitle = styled.span`
  display: inline;
  color: #8c8c8c;
  font-family: "Circular", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 15px;
  margin-left: 4px;
`


const Section = ({ className, children, title, subtitle, loading, renderActionButton }) => (
  <div className={className}>
    { loading ?
      <TitleWrapper>
        <SLHeader/>
      </TitleWrapper>
      :
      <TitleWrapper>
        <div>
          {title && <Title>{title}</Title>}
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </div>
        { renderActionButton && renderActionButton() }
      </TitleWrapper>
    }
    {children}
  </div>
)

export default styled(Section)`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-start;
  width: 100%;
  height: fit-content;
  margin: 8px 0;
  padding: ${props => props.nopad ? '0' : '0 0 40px 0'};
  border-bottom: 1px solid #e1e1e1;
  
  :last-child {
    border: none;
    margin-bottom: 0;
  }
`
